import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    t: "Discovery",
    d: "Deep audit of operations, stakeholders and current systems. We map what works, what wastes and what's worth building.",
  },
  {
    n: "02",
    t: "Setup & Configuration",
    d: "Platform stand-up, modules configured, integrations wired. Done in tight, milestone-driven sprints.",
  },
  {
    n: "03",
    t: "Training & Go-Live",
    d: "Role-based training for every stakeholder group. Phased rollout so adoption sticks from day one.",
  },
  {
    n: "04",
    t: "Ongoing CoE",
    d: "A dedicated Center of Excellence stays on — monitoring, optimising and evolving the platform with you.",
  },
];

const Methodology = () => {
  return (
    <section
      data-testid="methodology-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="font-mono text-xs text-[#0038FF]">[ 07 ]</span>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#0038FF]">
            How We Work
          </span>
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          data-testid="methodology-heading"
          className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl font-black tracking-tighter text-[#0a0a0a] mb-16 max-w-3xl break-words"
        >
          A four-step rhythm.
          <br />
          From kickoff to compound returns.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
          {steps.map((s, idx) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              data-testid={`methodology-step-${s.n}`}
              className="bg-white p-8 lg:p-10 min-h-[280px] flex flex-col justify-between group hover:bg-[#0a0a0a] hover:text-white transition-colors duration-500"
            >
              <div className="font-mono text-sm text-[#0038FF] group-hover:text-[#5b8bff] transition-colors">
                {s.n}
              </div>
              <div>
                <h3 className="font-display text-2xl lg:text-3xl font-bold tracking-tight mb-4">
                  {s.t}
                </h3>
                <p className="text-sm leading-relaxed text-[#4a4a4a] group-hover:text-white/75 transition-colors">
                  {s.d}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Methodology;
